import { ListItem as TiptapListItem } from 'tiptap-extensions'

const ALIGN_PATTERN = new RegExp(`(left|center|right|justify)`)

const ListItemNodeSpec = {
  attrs: {
    textAlign: { default: null },
    lineHeight: { default: null },
    style: { default: null },
  },
  content: 'paragraph block*',
  defining: true,
  draggable: false,
  parseDOM: [
    {
      tag: 'li',
      getAttrs,
    },
  ],
  toDOM,
}

// @ts-ignore
function getAttrs(dom) {
  let { textAlign } = dom.style

  let align = dom.getAttribute('data-text-align') || textAlign || ''
  align = ALIGN_PATTERN.test(align) ? align : null

  return {
    textAlign: align,
    style: dom.getAttribute('style') || null,
  }
}

function toDOM(node) {
  const { textAlign } = node.attrs

  let style = node.attrs.style
  const attrs = {}

  if (textAlign && textAlign !== 'left') {
    style += `text-align: ${textAlign}`
  }

  style && (attrs.style = style)

  return ['li', attrs, 0]
}

export default class ListItem extends TiptapListItem {
  get schema() {
    return ListItemNodeSpec
  }
}
